import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import axios from 'axios';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // 👈 1. Import useNavigate

const MatterForm = ({ openForm, setOpenForm, onAddLegalMatter }) => {
  // 2. Initialize useNavigate
  const navigate = useNavigate();
    
    const [formData, setFormData] = useState({
        matterName: '',
        client: '',
        estateNo: '',
        description: '',
        status: 'Pending', // Default value
        estateClassification: '', // 👈 Add this
    });

    // Handle input field changes
    const handleChange = (event) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = async () => {
        // Trim all form fields
        const trimmedFormData = {
            ...formData,
            matterName: formData.matterName?.trim() || "",
            client: formData.client?.trim() || "",
            estateNo: formData.estateNo?.trim() || "",
            description: formData.description?.trim() || "",
        };

        console.log("Submitting estateClassification:", trimmedFormData.estateClassification);
        // Log the form data to verify it's correctly populated
        console.log("Form Data to Send:", trimmedFormData);

        // Validate required fields
        if (!trimmedFormData.matterName || !trimmedFormData.client || !trimmedFormData.estateNo) {
            alert("Please fill in all required fields!"); 
            return;
        }

        // Use FormData to be compatible with multer
        const formDataObj = new FormData();
        formDataObj.append("matterName", trimmedFormData.matterName);
        formDataObj.append("client", trimmedFormData.client);
        formDataObj.append("estateNo", trimmedFormData.estateNo);
        formDataObj.append("description", trimmedFormData.description);
        formDataObj.append("status", trimmedFormData.status);
        formDataObj.append("estateClassification", trimmedFormData.estateClassification);

        try {
            const response = await axios.post(
                "https://ipms.insollex.com/api/legal-matter",
                formDataObj,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data && response.data.matter) {
                const newMatter = response.data.matter;
                onAddLegalMatter(newMatter); // update parent

                // 3. Navigate to the new matter's detail page
                // Assuming the detail page route is '/matter/:id'
                navigate(`/matter/${newMatter.id}`);

                setOpenForm(false); // close form
            } else {
                console.error("No data or no matter object returned from the server");
            }
        } catch (error) {
            console.error(
                "Error adding matter:",
                error.response ? error.response.data : error.message
            );
            alert("There was an error adding the matter. Please try again.");
        }
    };


    return (
        <Dialog open={openForm} onClose={() => setOpenForm(false)}>
            <DialogTitle>Add Legal Matter</DialogTitle>
            <DialogContent>
                <TextField
                    label="Estate Name"
                    name="matterName"
                    fullWidth
                    value={formData.matterName}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                />

                <TextField
                    label="Administrators Name"
                    name="client"
                    fullWidth
                    value={formData.client}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                />

                <TextField
                    label="Master Reference"
                    name="estateNo"
                    fullWidth
                    value={formData.estateNo}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                />

                {/* <TextField
                    label="Description"
                    name="description"
                    fullWidth
                    multiline
                    rows={3}
                    value={formData.description}
                    onChange={handleChange}
                    sx={{ mb: 2 }}
                /> */}

                {/* Estate Classification Dropdown */}
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel id="estate-classification-label">Estate Classification</InputLabel>
                    <Select
                        labelId="estate-classification-label"
                        id="estate-classification"
                        value={formData.estateClassification}
                        onChange={(e) =>
                            setFormData((prev) => ({ ...prev, estateClassification: e.target.value }))
                        }
                        label="Estate Classification"
                    >
                        <MenuItem value="Company">Company</MenuItem>
                        <MenuItem value="CC/BK">CC/BK</MenuItem>
                        <MenuItem value="Person">Person</MenuItem>
                    </Select>
                </FormControl>

                {/* Status Dropdown
                <FormControl fullWidth sx={{ mb: 2 }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        label="Status"
                    >
                        <MenuItem value="In Progress">In Progress</MenuItem>
                        <MenuItem value="Closed">Closed</MenuItem>
                        <MenuItem value="Pending">Pending</MenuItem>
                    </Select>
                </FormControl> */}
            </DialogContent>

            <DialogActions>
                <Button onClick={() => setOpenForm(false)}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained">
                    Submit
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default MatterForm;